const API = process.env.REACT_APP_BACKEND_URL;
const PORT = process.env.REACT_APP_PORT;
export {API, PORT};